import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'


const usePromotionsDetails = () => {
  const {promotionId} = useParams()
  const navigate = useNavigate()
  const location = useLocation();
  const promotionPageData = location.state.promotionPageData[0]
  console.log('promotionsData',promotionPageData,promotionId);

  return {
    promotionPageData,
    navigate
  }
}

export default usePromotionsDetails
